import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import usineImg from '../assets/imgusine.jpg';
import { useLanguage } from '../utils/LanguageContext';
import './SourcingFournisseurs.css';

const AVANTAGE_ICONS = [
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>,
];

const SERVICE_ICONS = [
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><polyline points="9 15 11 17 15 13"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
];

export default function SourcingFournisseurs() {
  const [openFaq, setOpenFaq] = useState(null);
  const navigate = useNavigate();
  const { t } = useLanguage();

  const AVANTAGES = useMemo(() => [
    { title: t('sf.av.1.title'), desc: t('sf.av.1.desc'), icon: AVANTAGE_ICONS[0] },
    { title: t('sf.av.2.title'), desc: t('sf.av.2.desc'), icon: AVANTAGE_ICONS[1] },
    { title: t('sf.av.3.title'), desc: t('sf.av.3.desc'), icon: AVANTAGE_ICONS[2] },
    { title: t('sf.av.4.title'), desc: t('sf.av.4.desc'), icon: AVANTAGE_ICONS[3] },
  ], [t]);

  const STEPS = useMemo(() => [
    { num: '01', title: t('sf.step.01.title'), desc: t('sf.step.01.desc') },
    { num: '02', title: t('sf.step.02.title'), desc: t('sf.step.02.desc') },
    { num: '03', title: t('sf.step.03.title'), desc: t('sf.step.03.desc') },
    { num: '04', title: t('sf.step.04.title'), desc: t('sf.step.04.desc') },
    { num: '05', title: t('sf.step.05.title'), desc: t('sf.step.05.desc') },
  ], [t]);

  const COMPARE = useMemo(() => [
    { aspect: t('sf.cmp.1.aspect'), avec: t('sf.cmp.1.avec'), sans: t('sf.cmp.1.sans') },
    { aspect: t('sf.cmp.2.aspect'), avec: t('sf.cmp.2.avec'), sans: t('sf.cmp.2.sans') },
    { aspect: t('sf.cmp.3.aspect'), avec: t('sf.cmp.3.avec'), sans: t('sf.cmp.3.sans') },
    { aspect: t('sf.cmp.4.aspect'), avec: t('sf.cmp.4.avec'), sans: t('sf.cmp.4.sans') },
    { aspect: t('sf.cmp.5.aspect'), avec: t('sf.cmp.5.avec'), sans: t('sf.cmp.5.sans') },
  ], [t]);

  const SERVICES = useMemo(() => [
    { title: t('sf.svc.1.title'), desc: t('sf.svc.1.desc'), icon: SERVICE_ICONS[0] },
    { title: t('sf.svc.2.title'), desc: t('sf.svc.2.desc'), icon: SERVICE_ICONS[1] },
    { title: t('sf.svc.3.title'), desc: t('sf.svc.3.desc'), icon: SERVICE_ICONS[2] },
    { title: t('sf.svc.4.title'), desc: t('sf.svc.4.desc'), icon: SERVICE_ICONS[3] },
    { title: t('sf.svc.5.title'), desc: t('sf.svc.5.desc'), icon: SERVICE_ICONS[4] },
    { title: t('sf.svc.6.title'), desc: t('sf.svc.6.desc'), icon: SERVICE_ICONS[5] },
  ], [t]);

  const FAQS = useMemo(() => [
    { q: t('sf.faq.1.q'), a: t('sf.faq.1.a') },
    { q: t('sf.faq.2.q'), a: t('sf.faq.2.a') },
    { q: t('sf.faq.3.q'), a: t('sf.faq.3.a') },
    { q: t('sf.faq.4.q'), a: t('sf.faq.4.a') },
    { q: t('sf.faq.5.q'), a: t('sf.faq.5.a') },
  ], [t]);

  return (
    <div className="sf-page">

      {/* ── HERO ── */}
      <section className="sf-hero">
        <div className="sf-hero__bg" style={{ backgroundImage: `url(${usineImg})` }} />
        <div className="sf-hero__inner">
          <p className="sf-hero__eye">{t('sf.hero.eye')}</p>
          <h1 className="sf-hero__h1">
            {t('sf.hero.h1a')}<br />
            <strong>{t('sf.hero.h1b')}</strong>
          </h1>
          <p className="sf-hero__sub">{t('sf.hero.sub')}</p>
          <div className="sf-hero__actions">
            <button
              className="sf-btn sf-btn--primary"
              onClick={() => navigate('/', { state: { scrollTo: 'contact-section' } })}
            >
              {t('sf.hero.cta')}
            </button>
            <a href="#sf-processus" className="sf-btn sf-btn--ghost">{t('sf.hero.process')}</a>
          </div>
        </div>
      </section>

      {/* ── AVANTAGES ── */}
      <section className="sf-avantages">
        <div className="sf-avantages__inner">
          <p className="sf-eyebrow">{t('sf.avantages.eye')}</p>
          <h2 className="sf-h2">{t('sf.avantages.h2a')}<strong>{t('sf.avantages.h2b')}</strong></h2>
          <p className="sf-lead">{t('sf.avantages.lead')}</p>
          <div className="sf-avantages__grid">
            {AVANTAGES.map((a) => (
              <div key={a.title} className="sf-avantage-card">
                <div className="sf-avantage-card__icon">{a.icon}</div>
                <h3 className="sf-avantage-card__title">{a.title}</h3>
                <p className="sf-avantage-card__desc">{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROCESSUS ── */}
      <section className="sf-processus" id="sf-processus">
        <div className="sf-processus__inner">
          <p className="sf-eyebrow">{t('sf.processus.eye')}</p>
          <h2 className="sf-h2">{t('sf.processus.h2a')}<strong>{t('sf.processus.h2b')}</strong></h2>
          <p className="sf-lead">{t('sf.processus.lead')}</p>
          <div className="sf-processus__steps">
            {STEPS.map((s) => (
              <div key={s.num} className="sf-process-step">
                <div className="sf-process-step__num">{s.num}</div>
                <h3 className="sf-process-step__title">{s.title}</h3>
                <p className="sf-process-step__desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── COMPARATIF ── */}
      <section className="sf-compare">
        <div className="sf-compare__inner">
          <p className="sf-eyebrow">{t('sf.compare.eye')}</p>
          <h2 className="sf-h2" style={{ color: '#ffffff' }}>
            {t('sf.compare.h2a')}<strong>{t('sf.compare.h2b')}</strong>
          </h2>
          <div style={{ overflowX: 'auto' }}>
            <table className="sf-compare__table">
              <thead>
                <tr>
                  <th>{t('sf.compare.th.aspect')}</th>
                  <th>{t('sf.compare.th.avec')}</th>
                  <th>{t('sf.compare.th.sans')}</th>
                </tr>
              </thead>
              <tbody>
                {COMPARE.map((row) => (
                  <tr key={row.aspect}>
                    <td>{row.aspect}</td>
                    <td><span className="sf-compare__check">✓</span> {row.avec}</td>
                    <td><span className="sf-compare__cross">✗</span> {row.sans}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section className="sf-services">
        <div className="sf-services__inner">
          <p className="sf-eyebrow">{t('sf.services.eye')}</p>
          <h2 className="sf-h2">{t('sf.services.h2a')}<strong>{t('sf.services.h2b')}</strong></h2>
          <p className="sf-lead">{t('sf.services.lead')}</p>
          <div className="sf-services__grid">
            {SERVICES.map((s) => (
              <div key={s.title} className="sf-service-card">
                <div className="sf-service-card__icon">{s.icon}</div>
                <h3 className="sf-service-card__title">{s.title}</h3>
                <p className="sf-service-card__desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="sf-faq">
        <div className="sf-faq__inner">
          <p className="sf-eyebrow">{t('sf.faq.eye')}</p>
          <h2 className="sf-h2">{t('sf.faq.h2a')}<strong>{t('sf.faq.h2b')}</strong></h2>
          <div className="sf-faq__list">
            {FAQS.map((faq, i) => (
              <div key={i} className="sf-faq__item">
                <button
                  className={`sf-faq__question${openFaq === i ? ' sf-faq__question--open' : ''}`}
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  {faq.q}
                  <svg className="sf-faq__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </button>
                <div className={`sf-faq__answer${openFaq === i ? ' sf-faq__answer--open' : ''}`}>
                  {faq.a}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="sf-cta">
        <h2 className="sf-cta__h2">{t('sf.cta.h2a')}<strong>{t('sf.cta.h2b')}</strong></h2>
        <p className="sf-cta__sub">{t('sf.cta.sub')}</p>
        <button
          className="sf-btn sf-btn--primary"
          onClick={() => navigate('/', { state: { scrollTo: 'contact-section' } })}
        >
          {t('sf.cta.btn')}
        </button>
      </section>

    </div>
  );
}
